import { SerdeDtoClass } from '@zaoblako/shared/modules/serde/classes/serde-dto.class';
import { SecurityDtoKeysEnum } from '@zaoblako/shared/modules/security/enums/security-dto-keys.enum';

import * as yup from 'yup';

/** Appication section's tab request body for rate plan create/update APIs - DTO signature */
export interface ApplicationTabRatePlanFormInterface {
  /** Is tab enabled in module */
  enabled: boolean;
}

/** Appication section's tab request body for rate plan create/update APIs - DTO schema */
export const ApplicationTabRatePlanFormDto = SerdeDtoClass.create<ApplicationTabRatePlanFormInterface>(
  SecurityDtoKeysEnum.APPLICATION_TAB_RATE_PLAN_FORM_DTO,
  {
    enabled: {
      label: 'Активна',
      hint: 'Определяет доступность вкладки на уровне модуля',
      serializer: yup.boolean(),
    },
  },
);
